import UpdateTaxClassificationInfos from './UpdateTaxClassificationInfos';

export default UpdateTaxClassificationInfos;
